<div class="subscription-container" *ngIf="!loading && ProductsToShow.length > 0">
  <div class="subscription-header">
    <h1>Wählen Sie einen Tarif, der am Besten zu Ihnen passt. </h1>
  </div>

  <div class="subscription-grid">
    <div *ngFor="let plan of ProductsToShow; let i=index" class="card-wrapper">
      <app-tarife-card class="tarifeCard" [plan]="plan" [ProductsToShow]="ProductsToShow"
        [loggedIn]="loggedIn"></app-tarife-card>
    </div>
  </div>

  <!-- <div class="subscription-footer">
    <p>* Um ein Produkt zu listen, benötigen Sie ein Account. Registreren Sie sich hier kostenlos. </p>
    <p>Sie haben bereits ein Account? Melden Sie sich hier an.</p>
  </div> -->
  <div class="subscription-footer">
    <p>* Alle Preise sind netto zzgl. MwSt. Die Abrechnung erfolgt jährlich.</p>
  </div>

</div>
<div *ngIf="loading || ProductsToShow.length === 0" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>